import React from 'react';
import PropTypes from 'prop-types';
import parseGGDriver from '../../../helpers/parseGGDriver';
import { LazyLoadImage } from 'react-lazy-load-image-component';

class MockUpFrontCol extends React.PureComponent {

    render() {
        const { mockUpFront } = this.props

        const _mockUpFront = parseGGDriver(mockUpFront || '');

        return (
            <div className="MockUpFront">
                {_mockUpFront && 
                <a href={mockUpFront} target="_blank">
                    <LazyLoadImage className='zoom' src={_mockUpFront} alt='Link' />
                </a>
                }
            </div>
        );
    }
}

MockUpFrontCol.propTypes = {
    mockUpFront: PropTypes.string,
};

export default MockUpFrontCol;
